<template>
  <!--visitSource = 2  PC端 -->
  <div :class="'listPageBoxStyleSet ' + (visitSource == 2?'kw_card_default_pc ':'kw_card_default ') + ((visitSource == 3 && !pageSetInfo.listStyleSet.showStyle)?('basicCard_'+(pageSetInfo.listStyleSet.showStyleTemplete?pageSetInfo.listStyleSet.showStyleTemplete:'0')):'')" :style="pageSetInfo.listStyleSet.listPageBoxStyleSet?pageSetInfo.listStyleSet.listPageBoxStyleSet.styleSetCode:''" kwName="listPageBoxStyleSet" >
    <template v-if="visitSource == 2 || visitSource == 3" >
      <!-- 左侧大图card -->
      <template  v-if="(pageSetInfo.listStyleSet.showStyle != 6)">
        <!-- 默认版 -->
        <div v-for="(havingOneInfo,havingIndex) in dataHavingList" :key="'havingInfo_'+havingIndex" :style="pageSetInfo.listStyleSet.listPageCardHavingBoxStyleSet?pageSetInfo.listStyleSet.listPageCardHavingBoxStyleSet.styleSetCode:''" kwName="listPageCardHavingBoxStyleSet" class="listPageCardHavingBoxStyleSet">
          <div v-if="havingOneInfo.havingFieldList"   :style="((havingOneInfo.ifShow&&pageSetInfo.listStyleSet.ifShowAllHaving==2)?'box-shadow: rgb(0 0 0 / 41%) 0px 2px 12px 0px;':'')+(pageSetInfo.listStyleSet.listPageCardHavingFieldBoxStyleSet?pageSetInfo.listStyleSet.listPageCardHavingFieldBoxStyleSet.styleSetCode:'')" kwName="listPageCardHavingFieldBoxStyleSet" class="listPageCardHavingFieldBoxStyleSet" @click="havingFieldBoxClick(havingIndex)">
            <template  v-for="(fieldInfo,fieldIndex) in havingOneInfo.havingFieldList">
              <kw_card_field :key="'havingFieldInfo_'+fieldIndex" :fieldInfo="fieldInfo" :fieldIndex="fieldIndex" :dataInfo="havingOneInfo.dataInfo" :dataIndex="havingOneInfo.dataIndex" :pageSetInfo="pageSetInfo" :isHaving="1"></kw_card_field>
            </template>
            <div v-if="pageSetInfo.listStyleSet.ifShowHavingNum==1" :style="(pageSetInfo.listStyleSet.listPageCardHavingNumStyleSet?pageSetInfo.listStyleSet.listPageCardHavingNumStyleSet.styleSetCode:'')" >{{havingOneInfo.maxIndex-havingOneInfo.minIndex}}</div>
          </div>
          <!-- 列表的聚合操作按钮 -->
          <div v-if="(pageSetInfo.operaButtonSet.length>0 && pageSetInfo.operaButtonSetIfHide)">
            <kw_btn_array :pageSetInfo="pageSetInfo" :dataInfo="havingOneInfo.dataInfo" :dataIndex="havingOneInfo.dataIndex" @dataButtonClick="dataButtonClick" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" :showCssStyle="11"></kw_btn_array>
          </div>
          <el-row  v-if="havingOneInfo.ifShow" :style="(pageSetInfo.listStyleSet.listPageCardBoxStyleSet?pageSetInfo.listStyleSet.listPageCardBoxStyleSet.styleSetCode:'')" kwName="listPageCardBoxStyleSet" class="listPageCardBoxStyleSet" justify="space-between">
            <template v-for="(dataInfo,dataIndex) in dataList">
              <!-- 显示聚合字段 -->
              <el-col :key="'dataInfo_'+havingIndex+'_'+dataIndex" v-if="dataIndex<havingOneInfo.maxIndex && dataIndex >= havingOneInfo.minIndex" :xs="pageSetInfo.listStyleSet.colNumXs?(pageSetInfo.listStyleSet.colNumXs*1):24" :sm="pageSetInfo.listStyleSet.colNumSm?(pageSetInfo.listStyleSet.colNumSm*1):24" :md="pageSetInfo.listStyleSet.colNumMd?(pageSetInfo.listStyleSet.colNumMd*1):24" :lg="pageSetInfo.listStyleSet.colNumLg?(pageSetInfo.listStyleSet.colNumLg*1):8" :xl="pageSetInfo.listStyleSet.colNumXl?(pageSetInfo.listStyleSet.colNumXl*1):8" class="iCol listPageCardCommonStyleSet" :style="styleSetCodeZdy(pageSetInfo.listStyleSet.listPageCardCommonStyleSet,dataInfo) +(pageSetInfo.listStyleSet.isShowCardBgImg==1&&dataInfo.BG_FILE?'background-image:url('+GLOBAL.getFileServeUrl()+dataInfo.BG_FILE+')':'') + (dataIndex == oneIndex?styleSetCodeZdy(pageSetInfo.listStyleSet.listPageCardCheckCommonStyleSet,dataInfo):'')" kwName="listPageCardCommonStyleSet" :class="(pageSetInfo.listStyleSet.cardSpecialBorder == 1?' curriculumListBoxNowBottomBorder ':' ') + (pageSetInfo.listStyleSet.listPageCardCommonStyleSet?pageSetInfo.listStyleSet.listPageCardCommonStyleSet.defineHover: ' ')" :data-index="(dataIndex)" @click.native="listDataClick(dataInfo,dataIndex)">
                
                <!-- card上部结构 -->
                <div v-if="pageSetInfo.listStyleSet.cardSubstructureTop == 2" class="listPageCardTopCommonStyleSet curriculumListTop" :style="pageSetInfo.listStyleSet.listPageCardTopCommonStyleSet?pageSetInfo.listStyleSet.listPageCardTopCommonStyleSet.styleSetCode:''" kwName="listPageCardTopCommonStyleSet">
                  <template  v-for="(fieldInfo,fieldIndex) in listFieldSet">
                    <kw_card_field  v-if="(fieldInfo.styleSet.cardPosition == 1)" :key="'fieldIndex_'+fieldIndex" :fieldInfo="fieldInfo" :fieldIndex="fieldIndex" :dataInfo="dataInfo" :pageSetInfo="pageSetInfo" :isHaving="0"  :dataIndex="dataIndex"></kw_card_field>
                  </template>
                </div>
                <img v-if="(dataInfo['XM_HOT'] == 2)" src="./img/hot_img.png" class="newHotImg"/>
                <div class="listPageCardLeftRightBoxStyleSet curriculumListBottom" :style="(pageSetInfo.listStyleSet.listPageCardLeftRightBoxStyleSet?pageSetInfo.listStyleSet.listPageCardLeftRightBoxStyleSet.styleSetCode:'')" kwName="listPageCardLeftRightBoxStyleSet">
                  <!-- 序号列 -->
                  <div v-if="pageSetInfo.listStyleSet.indexIfShow==1 || (!pageSetInfo.listStyleSet.showStyle && visitSource == 3)"  class="numIcon" :style="(pageSetInfo.listStyleSet.listPageNumStyleSet?pageSetInfo.listStyleSet.listPageNumStyleSet.styleSetCode:'')">{{dataIndex+1}}</div>
                  <!-- 复选框 -->
                  <el-checkbox v-if="pageSetInfo.listStyleSet.radioIfShow==1 || (dataMaxNum != 1 && ifDialog)" v-model="dataInfo.RADIO_CHECK_STATE" :checked="dataInfo.RADIO_CHECK_STATE?true:false" @change="(flag)=>radioCheckChange(flag,dataInfo)" :style="'float: left;margin: 0 2px 0 0;'+(pageSetInfo.listStyleSet.listRadioCheckStyleSet?pageSetInfo.listStyleSet.listRadioCheckStyleSet.styleSetCode:'')" kwName="listRadioCheckStyleSet" @click.native.stop=""></el-checkbox>
                  <!-- card左侧结构 -->
                  <div v-if="(pageSetInfo.listStyleSet.imgPosition)" :class="(pageSetInfo.listStyleSet.imgPosition && pageSetInfo.listStyleSet.imgPosition == 4?'cardRightLine':'')" :style="('float:left;')+(pageSetInfo.listStyleSet.listPageCardLeftBoxStyleSet?pageSetInfo.listStyleSet.listPageCardLeftBoxStyleSet.styleSetCode:'')" kwName="listPageCardLeftBoxStyleSet">
                    <!-- imgPosition 1:背景图片 2:上部图片 3:图片 4:文本 -->
                    <img v-if="(pageSetInfo.listStyleSet.imgPosition == 3 && dataInfo.BG_FILE)" class="PictureRadius_1 defaultLeftImg" :src="(dataInfo.BG_FILE?GLOBAL.getFileServeUrl()+dataInfo.BG_FILE:'./img/img_5.png')" :style="pageSetInfo.listStyleSet.listPageImageStyleSet?pageSetInfo.listStyleSet.listPageImageStyleSet.styleSetCode:''" kwName="listPageImageStyleSet"/>

                    <div v-if="(pageSetInfo.listStyleSet.imgPosition == 4)">
                      <div v-for="(fieldInfo,fieldIndex) in listFieldSet"  :key="'listField_'+fieldIndex">
                        <kw_card_field  v-if="(fieldInfo.styleSet.cardPosition == 4)" :key="'fieldIndex_'+fieldIndex" :fieldInfo="fieldInfo" :fieldIndex="fieldIndex" :dataInfo="dataInfo" :pageSetInfo="pageSetInfo" :isHaving="0" :dataIndex="dataIndex"></kw_card_field>
                      </div>
                    </div>

                    <div v-if="(pageSetInfo.listStyleSet.imgPosition == 1)">
                      <div v-for="(fieldInfo,fieldIndex) in listFieldSet" :key="'listField_'+fieldIndex">
                        <kw_card_field  v-if="(fieldInfo.styleSet.cardPosition == 4)" :key="'fieldIndex_'+fieldIndex" :fieldInfo="fieldInfo" :fieldIndex="fieldIndex" :dataInfo="dataInfo" :pageSetInfo="pageSetInfo" :isHaving="0"  :dataIndex="dataIndex"></kw_card_field>
                      </div>
                    </div>
                  </div>
                  <!-- card右侧结构 -->
                  <div class="listPageCardRightBoxStyleSet curriculumListRight_pc" :style="pageSetInfo.listStyleSet.listPageCardRightBoxStyleSet?pageSetInfo.listStyleSet.listPageCardRightBoxStyleSet.styleSetCode:''" kwName="listPageCardRightBoxStyleSet">
                    <div v-if="pageSetInfo.listStyleSet.cardRightIcon" class="cellLeftArrow">
                      <kw_icon :type="(pageSetInfo.listStyleSet.cardRightIcon)" size="18" color="#DADADA" ></kw_icon>
                    </div>
                    <div v-if="(dataInfo.NAME) && pageSetInfo.listStyleSet.cardTitle !=1" class="listFieldValueStyleSet curriculumListRightText multipleRowsText" :style="listFieldSet[0].styleSet.listFieldValueStyleSet?listFieldSet[0].styleSet.listFieldValueStyleSet.styleSetCode:''" kwName="listFieldValueStyleSet">
                      <span v-if="(dataInfo['XM_HOT'] == 1)" class="recommendHot">推荐</span> {{dataInfo.NAME}}
                    </div>
                    <el-row :type="cardInfo.length>1?'flex':''" :align="cardInfo.length>1?'middle':''">
                      <el-col v-for="(i,cardInfoIndex) in cardInfo" :key="'cardInfo'+cardInfoIndex" :xs="i.width>0?i.width*1:24" :sm="i.width>0?i.width*1:24" :md="i.width>0?i.width*1:24" :lg="i.width>0?i.width*1:24" :xl="i.width>0?i.width*1:24" :style="styleSetCodeZdy(pageSetInfo.listStyleSet.listPageCardRightStyleSet,dataInfo)" kwName="listPageCardRightStyleSet">
                        <template v-for="(fieldInfo,fieldIndex) in listFieldSet" >
                          <template v-if="(cardInfoIndex+1 == (fieldInfo.styleSet.isBlockShow?fieldInfo.styleSet.isBlockShow:1) && (fieldInfo.fieldAliasName != 'NAME' && fieldInfo.fieldAliasName != 'BG_FILE')) && (fieldInfo.fieldAliasName != 'BG_FILE' && fieldInfo.styleSet.isHavingField != 1) && (!fieldInfo.styleSet.cardPosition || fieldInfo.styleSet.cardPosition == 2)">
                            <kw_card_field :key="'listField_'+fieldIndex" :fieldInfo="fieldInfo" :fieldIndex="fieldIndex" :dataInfo="dataInfo" :pageSetInfo="pageSetInfo" :isHaving="0" :dataIndex="dataIndex" v-show="!(((visitSource == 3 && !pageSetInfo.listStyleSet.showStyle || pageSetInfo.listStyleSet.ColAfterHide > 0) && (fieldIndex > (pageSetInfo.listStyleSet.ColAfterHide?pageSetInfo.listStyleSet.ColAfterHide:6) && !dataInfo.SHOW_MORE_SIX)))"></kw_card_field>
                          </template>
                        </template>
                        <div v-if="listFieldSet.length > (pageSetInfo.listStyleSet.ColAfterHide?(pageSetInfo.listStyleSet.ColAfterHide+1):7) && ((visitSource == 3 && !pageSetInfo.listStyleSet.showStyle) || pageSetInfo.listStyleSet.ColAfterHide > 0)" style="position: absolute;right: 0px;top: 0px;color: red;" @click.stop="changeShowMoreSix(dataInfo)">{{(dataInfo.SHOW_MORE_SIX?'隐藏':'显示更多')}}</div>
                      </el-col>
                    </el-row>
                    <div>
                      <!-- 列表的操作按钮 -->
                      <div v-if="(pageSetInfo.operaButtonSet.length>0 && pageSetInfo.operaButtonSetIfHide)">
                        <kw_btn_array :pageSetInfo="pageSetInfo" :dataInfo="dataInfo" :dataIndex="dataIndex" @dataButtonClick="dataButtonClick" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" :showCssStyle="1"></kw_btn_array>
                      </div>
                    </div>
                    <!-- 商品热度标签 -->
                    <div v-if="(pageSetInfo.listStyleSet.epHotTip==2)" :class="(pageSetInfo.listStyleSet.epHotTipPos==1?'leftTopPos posPart':'posPart')">
                      <img :src="(dataInfo['EP_HOT']==3?require('./img/strongPush.png'):dataInfo['EP_HOT']==4?require('./img/mustListen.png'):dataInfo['EP_HOT']==5?require('./img/handPick.png'):'')" mode="widthFix"/>
                      <div class="hotTopCon">{{dataInfo['EP_HOT']==3?'强推':dataInfo['EP_HOT']==4?'必听':dataInfo['EP_HOT']==5?'精选':''}}</div>
                    </div>
                  </div>
                </div>
                <!-- card下部结构 -->
                <div v-if="(pageSetInfo.listStyleSet.cardSubstructure == 2)" :style="pageSetInfo.listStyleSet.listPageCardBottomCommonStyleSet?pageSetInfo.listStyleSet.listPageCardBottomCommonStyleSet.styleSetCode:''" kwName="listPageCardBottomCommonStyleSet" class="cardSubstructureBottom">
                  <div v-for="(fieldInfo,fieldIndex) in listFieldSet" :key="'fieldIndex_'+fieldIndex">
                    <kw_card_field  v-if="(fieldInfo.styleSet.cardPosition == 3)" :key="'fieldIndex_'+fieldIndex" :fieldInfo="fieldInfo" :fieldIndex="fieldIndex" :dataInfo="dataInfo" :pageSetInfo="pageSetInfo" :isHaving="0"></kw_card_field>
                  </div>
                </div>
                <!-- 加号展开 关联列表 -->
                
              </el-col>

            </template>
          </el-row>
        </div>
      </template>

      <!-- 详情页（中分） -->
      <!-- 图片文本任意搭配（背景&图片在上文本颜色） -->
      <div :class="'curriculumBlockSeparate '+('chgLastItemColor'+pageSetInfo.listStyleSet.lastfontColor)"  v-if="(pageSetInfo.listStyleSet.showStyle == 6)" :style="pageSetInfo.listStyleSet.listPageImageBoxStyleSet?pageSetInfo.listStyleSet.listPageImageBoxStyleSet.styleSetCode:''" kwName="listPageImageBoxStyleSet">
        <div v-for="(dataInfo,dataIndex) in dataList" :key="'dataInfo_'+dataIndex" :style="(dataList.length==1?'width:100%;':'')+(pageSetInfo.listStyleSet.listPageImageForStyleSet?pageSetInfo.listStyleSet.listPageImageForStyleSet.styleSetCode:'')" kwName="listPageImageForStyleSet">
          <!-- pageSetInfo.listStyleSet.imgPosition == 1 背景图片 -->
          <div v-if="(pageSetInfo.listStyleSet.imgPosition && pageSetInfo.listStyleSet.imgPosition == 1)" class="curriculumListBoxBgSeparate" @click="listDataClick(dataInfo)" :style="'background-image:url('+(dataInfo.BG_FILE?GLOBAL.getFileServeUrl()+dataInfo.BG_FILE:require('./img/img_4.png'))+');' + (pageSetInfo.listStyleSet.listPageImageStyleSet?pageSetInfo.listStyleSet.listPageImageStyleSet.styleSetCode:'')" kwName="listPageImageStyleSet">
            <div v-for="(fieldInfo,fieldIndex) in listFieldSet" :key="'field_'+fieldIndex">
              <div v-if="(fieldInfo.styleSet.cssStyle!=5)" :style="fieldInfo.styleSet.listFieldValueStyleSet?fieldInfo.styleSet.listFieldValueStyleSet.styleSetCode:''" kwName="listFieldValueStyleSet">
                {{dataInfo.NAME}}
              </div>
              <div v-if="(dataInfo.MAJOR_XW && fieldInfo.styleSet.cssStyle!=5)" :style="fieldInfo.styleSet.listFieldValueStyleSet?fieldInfo.styleSet.listFieldValueStyleSet.styleSetCode:''" kwName="listFieldValueStyleSet">
                {{dataInfo.MAJOR_XW}}
              </div>
            </div>
          </div>

          <!-- pageSetInfo.listStyleSet.imgPosition == 2 上部图片 -->
          <div v-if="(pageSetInfo.listStyleSet.imgPosition && pageSetInfo.listStyleSet.imgPosition == 2)" :class="(pageSetInfo.listStyleSet.imgBoxWidth==1?'defultCurriculumListBoxSeparate':'curriculumListBoxSeparate')" @click="listDataClick(dataInfo)">
            <img class="PictureRadius_1" :style="pageSetInfo.listStyleSet.listPageImageStyleSet?pageSetInfo.listStyleSet.listPageImageStyleSet.styleSetCode:''" kwName="listPageImageStyleSet" :src="(dataInfo.BG_FILE?GLOBAL.getFileServeUrl()+dataInfo.BG_FILE:require('./img/img_4.png'))"/>
            <div class="curriculumListRightText curriculumListRightTextSeparate" v-for="(fieldInfo,fieldIndex) in listFieldSet" :key="'field_'+fieldIndex" v-if="(fieldInfo.styleSet.cssStyle!=5)" :style="fieldInfo.styleSet.listFieldValueStyleSet?fieldInfo.styleSet.listFieldValueStyleSet.styleSetCode:''" kwName="listFieldValueStyleSet">{{dataInfo.NAME}}</div>
          </div>
        </div>
      </div>

      <kw_look v-if="detailPageInfo.ifLoaded" :pageInfo="detailPageInfo" @goBack="goBack" :isLimitButton="isLimitButton"  @getParentKwLook="getParentKwLook" @getParentKwList="getParentKwList"></kw_look>
    </template>




    <!--visitSource = 3  移动端 -->
    <template v-else>
      
    </template>
    <el-dialog class="zdy_dialog" v-if="dialogInfo.ifLoad" :visible.sync="dialogInfo.ifLoad" width="90%" top="1vh" center append-to-body :close-on-click-modal="false">
        <template slot="title"> 
            <div>
                {{(dialogInfo.pageInfo&&dialogInfo.pageInfo.menuName)?dialogInfo.pageInfo.menuName:'弹出层'}}
            </div>    
        </template>
        <kw_list v-if="dialogInfo.type==1" ref="kw_list_dialog" :initPageObj="dialogInfo.pageInfo" :isLimitButton="isLimitButton" :ifDialog="1"></kw_list>
        <kw_look v-else-if="dialogInfo.type==11" ref="kw_look_dialog" :pageInfo="dialogInfo.pageInfo" @goBack="dialogIframeZdyCancel" :isLimitButton="isLimitButton" :ifDialog="1"></kw_look>
        <iframe v-else-if="dialogInfo.type==999" ref="dialog999" :style="'width:100%;height:' + (windowHeight-70) + 'px;'" frameborder=0 name="showHere" scrolling=auto  :src="dialogInfo.url" ></iframe>
        <span slot="footer" v-if="dialogInfo.type==999">
            <el-button @click="dialogIframeZdyCancel">取 消</el-button>
            <el-button type="primary" @click="dialogIframeZdyConfirm">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 文件预览组件 -->
    <el-dialog class="zdy_dialog" :modal="false" v-if="filePreviewInfo.ifLoad" v-show="filePreviewInfo.ifShow" :title="filePreviewInfo.name" :visible.sync="filePreviewInfo.ifLoad" width="100%" top="1vh" center append-to-body v-dialogDrag>
      <kw_file_preview v-model="filePreviewInfo"></kw_file_preview>
    </el-dialog>
  </div>
</template>

<script>
//card字段组件 kw_card_field
import kw_card_field from '@/components/list/kw_card_field.vue';
// 状态聚合组件 
import kw_having_view from '@/components/look/kw_having_view.vue';
// 人员头像列表组件 
import kw_avatar from '@/components/look/kw_avatar.vue';
// 进度形式
import kw_progress from '@/components/list/kw_progress.vue';
// 倒计时
import kw_count_down from '@/components/form/kw_count_down.vue';
// 列表的按钮组件
import kw_btn_array from '@/components/look/kw_btn_array.vue';
import kw_icon from '@/components/kw/kw_icon.vue';
// 图片预览组件 kw_preview_image
import kw_preview_image from '@/components/look/kw_preview_image.vue';
// 二维码组件
import vueQr from 'vue-qr'
import VueBarcode from "vue-barcode";
// 文件预览组件
import kw_file_preview from '@/components/kw/kw_file_preview.vue';

import pageUtils from '@/js/page/pageUtil.js'; 
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_card_default',
  props: {
    pageSetInfo:{
      type: Object,
      value: null
    },
    listFieldSet: {
      type: Array,
      value: null
    },
    //列表数据全部显示
    dataList:{
      type: Array,
      value: null
    },
    //单一一条数据进行显示
    dataInfo: {
      type: Object,
      value: null
    },
    initDataIndex:{
      type: Number,
      value: 0
    },
    previewVisitSource:{
      type:Number,
      default:0
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    },
    dataMaxNum:{
      type:Number,
      default:1
    },
    ifDialog:{
      type:Boolean,
      default:false
    },
    // 初始的默认选中值
    initCheckId: {
      type: String,
      value: null
    },
  },
  data() {
    var that = this;
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(that),
      //card分块循环次数
      cardInfo:[{width:0}],
      detailPageInfo:{},
      // 聚合后的数据结构
      dataHavingList:[],
      /**
       * 弹出层组件的信息
       */
      dialogInfo:{
          ifLoad:false
      },
      oneIndex:-1,
      /**
       * 文件预览组件的信息
       */
      filePreviewInfo:{
          name:'文件预览',
          ifLoad:false,
          ifShow:false
      },
    };
  },
  created() {
    var that = this;
    var pageSetInfo = that.pageSetInfo;
    var styleSet = pageSetInfo.listStyleSet;
    if(this.pageSetInfo.listStyleSet.setBlockingCard && this.pageSetInfo.listStyleSet.setBlockingCard.length > 0){
        this.cardInfo = this.pageSetInfo.listStyleSet.setBlockingCard
        
    } 
    this.updataDataList();
  },
  mounted() {
    
  },
  watch:{
    dataList:function(newVal){
      console.log("dataList-----------------watch");
      this.updataDataList();
    }
  },
  computed:{
  },
  components: {
    kw_card_field,
    kw_having_view,
    kw_avatar,
    kw_progress,
    kw_count_down,
    kw_btn_array,
	  kw_icon,
    kw_preview_image,
    vueQr,
    'barcode': VueBarcode,
    kw_file_preview,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {
    styleSetCodeZdy(json,rowData) {
      if(json) {
        var styleSetCode = json.styleSetCode;
        if(json.zdyJs) {
          styleSetCode += eval(json.zdyJs);
        }
        return styleSetCode;
      } else {
        return "";
      }
    },
    /**
     * 进行数据的结构处理
     */
    updataDataList(){
      var that = this;
      var dataList = this.dataList;
      // 循环判断 是否有合并列 如果有合并列 则进行显示合并
      var ifHavingCol = false;
      this.listFieldSet.forEach((fieldInfo)=>{
        if(fieldInfo.styleSet != null && fieldInfo.styleSet.cssStyle == 13 || fieldInfo.styleSet.isHavingField == 1) {
          ifHavingCol = true;
        }
      })
      var dataHavingList = [];
      //有聚合列时聚合数据是否切换显示 
      var ifShowAllHaving = (this.pageSetInfo.listStyleSet&&this.pageSetInfo.listStyleSet.ifShowAllHaving==2)?false:true;
      if (dataList) {
        if(!ifHavingCol) {
          dataHavingList.push({minIndex:0,maxIndex:dataList.length,ifShow:true});
        }
        var initCheckId = that.initCheckId;
        dataList.forEach((dataInfo,dataIndex) => {
          if(dataInfo.RADIO_IF_CHECK==1) {
            dataInfo.RADIO_CHECK_STATE = true;
          } else {
            dataInfo.RADIO_CHECK_STATE = false;
          }
          if(initCheckId && initCheckId != "") {
            if((","+initCheckId+",").indexOf(","+dataInfo["T_"+that.pageSetInfo.tableId+"_0"]+",")>=0) {
              dataInfo.RADIO_CHECK_STATE = true;
            }
          }

          var ifChangehaving = false;
          var prevJson;
          if(dataHavingList.length > 0) {
            prevJson = dataHavingList[dataHavingList.length-1];
          }
          var havingFieldList = [];
          if(prevJson == null) {
            ifChangehaving = true;
          }
          this.listFieldSet.forEach((fieldInfo)=>{
            if(fieldInfo.styleSet != null && (fieldInfo.styleSet.cssStyle == 12 || fieldInfo.styleSet.cssStyle == 14)) {
              if (dataInfo[fieldInfo.fieldAliasName] && (typeof(dataInfo[fieldInfo.fieldAliasName]) == 'string')) {
                var arr = dataInfo[fieldInfo.fieldAliasName].split(",");
                dataInfo[fieldInfo.fieldAliasName] = arr;
              }
            }
            if (typeof (dataInfo[fieldInfo.fieldAliasName]) == "string") {
              dataInfo[fieldInfo.fieldAliasName] = dataInfo[fieldInfo.fieldAliasName].replace(/_@/g, "\n");
            }
            if(ifHavingCol && fieldInfo.styleSet != null && (fieldInfo.styleSet.cssStyle == 13 || fieldInfo.styleSet.isHavingField == 1)) {
              havingFieldList.push(fieldInfo);
              if(prevJson == null || (dataInfo[fieldInfo.fieldAliasName] != prevJson.dataInfo[fieldInfo.fieldAliasName] && typeof(dataInfo[fieldInfo.fieldAliasName]) != "object")) {
                ifChangehaving = true;
              }
            }
          })
          if(ifChangehaving) {
            prevJson = {minIndex:dataIndex,maxIndex:dataIndex+1,ifShow:ifShowAllHaving};
            prevJson.dataInfo = dataInfo;
            prevJson.dataIndex = dataIndex;
            prevJson.havingFieldList = havingFieldList;
            if(dataHavingList.length == 0) {
              prevJson.ifShow = true;
            }
            dataHavingList.push(prevJson);
          } else {
            prevJson.maxIndex = prevJson.maxIndex+1;
          }
        })
        
        if(dataList.length > 0) {
          if ((this.pageSetInfo.listStyleSet.clickType == 2 && this.dataList.length > 0)||(this.pageSetInfo.operaButtonSet && this.pageSetInfo.operaButtonSet.length > 0 && this.pageSetInfo.operaButtonSet[0].styleSet.openWay == 6)) {
            this.oneIndex = 0;
            pageUtils.listDataClick(this, this.dataList[0]);
          }
        }
      }
      this.dataHavingList = dataHavingList;
      console.log("dataHavingList==================================",this.dataHavingList);
      // this.dataList = dataList;
      this.$forceUpdate();
    },
    /**
     * 列表数据点击时 进行跳转
     */
    listDataClick(dataInfo,dataIndex){
      this.oneIndex = dataIndex;
      pageUtils.listDataClick(this, dataInfo);
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo,dataIndex) {
      this.oneIndex = dataIndex;
      pageUtils.dataButtonClick(this,detail,dataInfo);
    },
    /**
     * 调用列表数据刷新方法
     */
    initLoadDataInfo:function(){
//      this.triggerEvent("refreshevent");
        this.$emit("refreshevent");
    },
    /**
     * 复选框选中时 调用列表第一个按钮
     */
    radioCheckChange:function(flag,dataInfo){
      var that = this;
      console.log("RADIO_CHECK_STATE=============",flag,dataInfo.RADIO_CHECK_STATE);
      // dataInfo.RADIO_CHECK_STATE = flag;
      
      // pageUtils.dataListButtonClick(that,dataInfo);
      this.$forceUpdate();
    },
    /**
     * 返回前一页
     */
    goBack(){
      this.$emit("goBack");
    },
    /**
     * 弹出层打开iframe时的确定按钮
     */
    dialogIframeZdyConfirm(){
      var that = this;
      that.$refs.dialog999.contentWindow.closeDialogFun=function(){
        that.dialogInfo.ifLoad = false;
      };
      that.$refs.dialog999.contentWindow.saveZdyPage();
    },
    /**
     * 弹出层打开iframe时的取消按钮
     */
    dialogIframeZdyCancel(ifRefresh){
      var that = this;
      this.dialogInfo.ifLoad = false;
      if(ifRefresh == 1) {
          this.refreshevent();
      }
    },
    refreshevent:function(){
      this.$emit("refreshevent");
    },
    /**
     * 获取最外层的的kw_look组件
     */
    getParentKwLook(callback) {
      console.log("kw_card_default========getParentKwLook========");
      if(this.$listeners['getParentKwLook']){
        var parentKwLook;
        this.$emit("getParentKwLook",val => {
            parentKwLook = val
        });
        callback(parentKwLook);
      } else {
        callback(null);
      }
    },
    getParentKwList(callback) {
      callback(this);
    },
    /**
     * 打开文件预览组件
     */
    toPreviewFile:function(dataInfo,fieldone) {
        console.log("fieldone======================",fieldone);
        var that = this;
        var file = {};
        file.name = dataInfo[fieldone.fieldAliasName+"_NAME"];
        file.downAddress = dataInfo[fieldone.fieldAliasName+"_DOWNADDRESS"];
        pageUtils.toPreviewFile(that,file,fieldone);
        // window.open(url);
    },
    //聚合字段点击时 触发事件
    havingFieldBoxClick:function(havingIndex){
      var dataHavingList = this.dataHavingList;
      var havingOne = dataHavingList[havingIndex];
      var ifShowAllHaving = (this.pageSetInfo.listStyleSet&&this.pageSetInfo.listStyleSet.ifShowAllHaving==2)?false:true;
      if(!ifShowAllHaving) {
        dataHavingList.forEach((fieldInfo,fieldInex)=>{
          if(fieldInex != havingIndex) {
            fieldInfo.ifShow = false;
          } else {
            havingOne.ifShow = true;
          }
        })
        console.log("dataHavingList========================",dataHavingList,havingIndex);
        this.listDataClick(havingOne.dataInfo,havingOne.dataIndex);
      }
    },
    /**
     * 隐藏预览组件
     */
    hiddenPreviewDialog:function(){
        this.filePreviewInfo.ifShow = false;
    },
    /**
     * 销毁预览组件
     */
    destoryPreviewDialog:function(){
        this.filePreviewInfo.ifLoad = false;
    },
    changeShowMoreSix:function(dataInfo){
      console.log("dataInfo=================",dataInfo);
      if(!dataInfo.SHOW_MORE_SIX) {
        this.$set(dataInfo,"SHOW_MORE_SIX",true);
      } else {
        this.$set(dataInfo,"SHOW_MORE_SIX",!dataInfo.SHOW_MORE_SIX);
      }

      // dataInfo.SHOW_MORE_SIX=!dataInfo.SHOW_MORE_SIX
    },
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 图片形状 */
/* imgRadius  1  2  3 */
.PictureRadius_1{border-radius: 5px}

.PictureRadius_2{border-radius: 65px}

.PictureRadius_3{border-radius: 75px}

/* 背景图片行高 */
.bgLignHeight5{line-height: 50px}
.bgLignHeight6{line-height: 75px}
.bgLignHeight7{line-height: 30px}
.bgLignHeight8{line-height: 50px}

/* 首页 */
/* 图片尺寸 */
/* imgWidthHeight  1  2  3 */

.PictureSize_1{width: 100px;height: 80px}

.PictureSize_2{width: 50px;height: 90px}


.PictureSize_3{width: 65px;height: 65px}
/* 左右展示 */

.PictureSize_4{width: 75px;height:55px}

.PictureSize_5{height: 50px;width: 212px;}

.PictureSize_6{width: 75px;height: 75px;}

.PictureSize_7{width: 90px;height: 30px}

.PictureSize_8{width: 100px;height: 50px;}

.PictureSize_9{width: 95%;height: 80px;}

.PictureSize_10{width: 100%;height: 50px;border-radius:99px;}

/* 单行两列 */
.orderNum{display:flex;justify-content: space-between;font-size: 13px;background:#fff;line-height:2;align-items:center}
.orderNum_pc{display:flex;justify-content: space-between;font-size: 13px;line-height:2;align-items:center}
.leftPart{color:#999;display:flex;}
.rightPart{color:#999;display:flex;align-items: center}
/*倒计时*/
.positionRight{position: absolute;top: 0px;right: 0;font-size: 14px;}
.positionRight_pc{position: absolute;top: 0px;right: 10px;font-size: 14px;}

/* 详情页（中分）card开始 */
/* 上部图片 */
.curriculumBlockSeparate{display: flex;justify-content: space-between;flex-wrap: wrap;padding: 20px}
.curriculumListBoxSeparate{display: flex;align-items: center;flex-direction: column;width: 100px;}
.defultCurriculumListBoxSeparate{display: flex;align-items: center;flex-direction: column;}
.curriculumListRightTextSeparate{text-align: center}
/* 背景图片 */
.curriculumListBoxBgSeparate{display:flex;align-items: center;box-sizing: border-box;background-repeat: no-repeat;color: #fff;font-size: 14px;text-align: center;background-size: 100% 100%;border-radius: 10px;margin-top: 10px;}

/* card */
.curriculumBlock{padding: 0 10px;background: #fff;}
.cardRightLine{border-right: 1px solid #DCDCDC;padding-right: 10px}

/* card定位金额 */
.pricePosition{position:absolute;right:0;bottom:-15px;}
.pricePosition_pc{position:absolute;right:0;bottom:-15px;}

.prevPrice{color:#9A9A9A;font-size:12px;text-decoration: line-through}
.nowPrice{color:#FF4848;font-size:14px;}
.priceBox{display: flex;flex-direction: column;align-items: center}
.priceBox_pc{display: flex;flex-direction: column;align-items: baseline}
.classtime{color:#666666;font-size:12px;line-height:2}
.btnBlock{margin: 5px 0}
/* 最后一个item字体颜色是否不同 */
.chgLastItemColor1 div:last-child div{color:#FC890C!important;}
.curriculumListRightText{font-size: 15px;color: #5A5A5A}
.curriculumListRightTextChild{font-size: 14px;}
/*.curriculumListBoxNow{padding: 0;margin: 0 10px 15px;position:relative;box-shadow: 0 0 15px #ddd;border-radius: 10px;min-height: 50px;left: 5px}*/
.curriculumListBoxNow{padding: 0;margin: 0 10px 15px;position:relative;box-shadow: 0 0 15px #ddd;border-radius: 10px;min-height: 50px;}

.curriculumListBoxNowBottomBorder:after{content: '';position: absolute;border:1px solid #eee;width: 97%;height: 7px;background: #fff;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;left: 5px;border-top: none;bottom:-9px;}

.curriculumListRight{position:relative;width:100%;}
.curriculumListRight_pc{position:relative;overflow: hidden;}
.curriculumListBox{position: relative;min-height: 50px;}

/* 新增card上下结构class */
.curriculumListBottom{justify-content: flex-start;align-items: center}




.numIcon {float: left;width:20px;text-align:center;color:#fff;background:#FF5764;font-weight: normal;border-radius: 3px;height:20px;line-height:20px;vertical-align: middle;margin: 5px 3px 0 0}
.nameEn {font-size: 10px;height: 12px;line-height:12px;display: block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-weight: normal;}

/*文本超出... */
.ellipsis{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width: 130px;display: block;height:20px;line-height:20px;}
/* card文本前图标 */
.textBeforeIcon{width: 14px;height: 14px;display: inline-block;padding-right: 5px;vertical-align:middle;}
/* card下部结构 */
.cardSubstructureBottom{display: flex;justify-content: space-between;align-items: center;}
.cardSubstructureBottom .textBeforeIcon{width: 18px;height: 16px;vertical-align: text-bottom;}
/* 括号 */
.brackets{color: #5A5A5A}

.leftTopPos {position:absolute;top:-20px;left:-10px;font-size:14px;color:#fff;width:50px;display:flex;justify-content: center;align-items: center;font-weight: bold;}
.newLeftTopPos{position:absolute;top:-22px;left:-10px;font-size:14px;color:#fff;/*width:200px;*/display:flex;justify-content: center;align-items: center;font-weight: bold;background:#FEEDE5;border-top-right-radius: 23px;border-bottom-right-radius: 23px}
.posPart img {width:50px;}
.leftTopPos .hotTopCon {position:absolute;top:2px}


/* 项目热度 */
.newHotImg{position: absolute;right: 0;bottom: 0;height: 49px;width: 60px}
.recommendHot{background:red;font-size: 14px;color: #fff;padding: 0 5px;border-radius: 5px;margin-right: 5px}

/* 点赞数图标 */
.imageFabulous{width: 14px;height: 14px;margin-right: 5px}

/* 列表箭头 */
.cellLeftArrow{position: absolute;right: 0;top: 0}

/* 多行文本溢出 */
.multipleRowsText{overflow: hidden;text-overflow: ellipsis;display: -webkit-box;word-break: break-all;-webkit-box-orient: vertical;-webkit-line-clamp: 2; }
.multipleRowsTextOne{overflow: hidden;text-overflow: ellipsis;display: -webkit-inline-box;word-break: break-all;-webkit-box-orient: vertical;-webkit-line-clamp: 1;}


/*值的默认样式*/
.valueStyleDefault{font-size: 13px;color: #999;}

/*左侧图片的默认样式*/
.defaultLeftImg{width:100px;height:100px}

/* 下部图片排列 */
.bgImageThree{
  width: 30%;
  height: 100px;
  margin: 0 1px 0 1px;
}
.bgImageOne{
  width: 100%;
  height: 100%;
}
.bgImageThreeBox{display: flex;justify-content: flex-start;flex-wrap: wrap;}


/* 默认样式 */
.basicCard_0 .listPageCardCommonStyleSet{
  background: #F8F8F8;
}
.basicCard_0 .listPageCardCommonStyleSet{
  margin: 0 0 10px 0;
  background:#ffffff;
}
.basicCard_0 .listPageCardLeftRightBoxStyleSet{
  padding: 10px 10px;
}

</style>